import { render, staticRenderFns } from "./HorizontalBannersDetail.vue?vue&type=template&id=1c5f0882&scoped=true"
import script from "./HorizontalBannersDetail.vue?vue&type=script&lang=js"
export * from "./HorizontalBannersDetail.vue?vue&type=script&lang=js"
import style0 from "./HorizontalBannersDetail.vue?vue&type=style&index=0&id=1c5f0882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f0882",
  null
  
)

export default component.exports